module.exports = __webpack_public_path__ + "img/lan_tour_route_03.5290bae3.jpg";